import {
	AfterViewInit,
	Component,
	Input,
	OnChanges,
	SimpleChanges,
	ViewChild,
} from '@angular/core';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {
	MatTableDataSource,
	MatTable,
	MatNoDataRow,
	MatColumnDef,
	MatHeaderCellDef,
	MatHeaderCell,
	MatCellDef,
	MatCell,
	MatHeaderRowDef,
	MatHeaderRow,
	MatRowDef,
	MatRow,
} from '@angular/material/table';
import { DataSetComponent } from 'src/app/components/data-set/data-set.component';
import { ApiLoadingKeys, ApiService } from 'src/app/services/api.services';
import { LoadingIndicatorService } from 'src/app/services/loading-indicator.service';
import { Contact } from '../../../models/contacts';
import {
	DataSetComponent as DataSetComponent_1,
	DataSetContentComponent,
} from '../../../components/data-set/data-set.component';
import { DataSetTableWithoutPaginatorComponent } from '../../../components/data-set/data-set-table.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { PhoneNumberPipe } from '../../../components/pipes';
import { DataSetLoadingRowComponent } from '../../../components/data-set/data-set-loading-row.component';

@Component({
	selector: 'app-list-of-contact',
	templateUrl: './list-of-contact.component.html',
	styleUrls: ['./list-of-contact.component.scss', '../../common/main.scss'],
	imports: [
		DataSetComponent_1,
		DataSetContentComponent,
		DataSetTableWithoutPaginatorComponent,
		MatTable,
		MatSort,
		MatNoDataRow,
		MatColumnDef,
		MatHeaderCellDef,
		MatHeaderCell,
		MatSortHeader,
		MatCellDef,
		MatCell,
		MatHeaderRowDef,
		MatHeaderRow,
		MatRowDef,
		MatRow,
		PhoneNumberPipe,
		DataSetLoadingRowComponent,
	],
})
export class ListOfContactComponent implements AfterViewInit, OnChanges {
	@ViewChild(DataSetComponent) dataSet!: DataSetComponent;
	@ViewChild(MatSort) sort!: MatSort;

	@Input() displayedColumns!: string[];
	@Input() dataSource!: MatTableDataSource<Contact>;
	@Input() isEditing!: boolean;
	@Input() clientId!: string;

	getContactsLoadingKey = ApiLoadingKeys.getContacts;
	finishedLoadingInitData: boolean = false;
	visibleIfSMSNotification: boolean = true; //* To control visibility of Phone Number field based on SMS Notification checkbox

	constructor(
		public readonly loadingService: LoadingIndicatorService,
		private readonly apiService: ApiService
	) {
		this.smsNotificationFlagCheck();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if ('dataSource' in changes) {
			this.finishedLoadingInitData = Array.isArray(this.dataSource?.data);
		}
	}

	smsNotificationFlagCheck(): void {
		// Checks that the active company has the sms Notifications feature enabled :
		this.apiService
			.getCompanySettingByName('smsNotifications')
			.then((companySetting) => {
				this.visibleIfSMSNotification = companySetting?.value
					?.toLowerCase()
					?.startsWith('true')
					? true
					: false;
			});
	}

	ngAfterViewInit(): void {
		if (this.dataSource && this.sort) {
			this.dataSource.sort = this.sort;
		}
	}
}
